import * as React from 'react';
import { Filters } from '../../Filters/filters';
import { useActions } from '../viewModalActions';
import { View } from '../../../types/View';
import { ModalGroup, ModalGroups } from '../../ModalGroup/modalGroup';
import './pageFilters.scss';
import { useSelector } from '../../../utils/useSelector';
import { Toggler } from '../../Toggler/toggler';
import TooltipPopover from '../../Popover/popover';

export const PageFilters = () => {
  const selectedWorkspace = useSelector(s => s.planning?.selectedWorkspace);
  const isMyItemsView = useSelector(s => s.viewModal?.isMyItemsView);
  const preApplyFilters = useSelector(s => s.viewModal?.preApplyFilters);
  const filters = useSelector(s => s.viewModal?.filters);
  const viewRefId = useSelector(s => s.viewModal?.refId);
  const parentView = useSelector(s => s.viewModal?.parentView);
  const getAPI = useSelector(s => s?.app?.elFn?.getAPI);
  const schemas = useSelector(s => s.planning?.selectedWorkspace?.schemas);
  const defaultFilters = useSelector(
    s => s.planning?.selectedWorkspace?.setting?.props?.defaultFilters
  );
  if (!selectedWorkspace) return null;
  const { setFilter, setFilters } = useActions();

  const isMyExpiryDashBoardModal = useSelector(
    s => s.viewModal?.isMyExpiryDashboard
  );

  const [showRequiredFilterGroup, setShowRequiredFilterGroup] = React.useState(
    filters?.some(f => f.isRequired) || false
  );

  const handleToggleChange = () => {
    if (showRequiredFilterGroup) {
      filters.forEach(f => {
        if (f.isRequired) {
          setFilter({ ...f, isRequired: false }, false, false, true);
        }
      });
    }
    setShowRequiredFilterGroup(!showRequiredFilterGroup);
  };

  const requiredFilters = filters?.filter(f => f.isRequired);

  return (
    <ModalGroups>
      <ModalGroup
        id="applyFilterGroup"
        label="Apply Filters to the View (Recommended)"
        text="Selected filters will be applied to customize & show only the relevant CPP data in the view"
      >
        <Filters
          setFilter={(f: View.FiltersField) => setFilter(f, true)}
          addFilter={
            isMyItemsView
              ? null
              : (f: View.FiltersField) => setFilter(f, true, false, true)
          }
          addAnotherFilter={
            isMyItemsView
              ? null
              : (f: View.FiltersField) => setFilter(f, true, false, true, true)
          }
          removeFilter={
            isMyItemsView && !isMyExpiryDashBoardModal
              ? null
              : (f: View.FiltersField) => setFilter(f, true, true)
          }
          setFilters={(filters: View.FiltersField[]) =>
            setFilters(filters, true, true)
          }
          schemas={schemas}
          defaultFilters={defaultFilters}
          getAPI={getAPI}
          filters={preApplyFilters}
          viewRefId={viewRefId}
          seeAllFilters={true}
        />
      </ModalGroup>
      <ModalGroup
        id="displayFilterGroup"
        label="Select Display Filters for Users"
        text="Selected filter options will be displayed to the end users on the view page"
      >
        <Filters
          addFilter={(f: View.FiltersField) => setFilter(f, false, false, true)}
          removeFilter={(f: View.FiltersField) => setFilter(f, false, true)}
          setFilter={(f: View.FiltersField) => setFilter(f, false)}
          setFilters={(filters: View.FiltersField[]) =>
            setFilters(filters, true, false)
          }
          filters={filters}
          schemas={schemas}
          defaultFilters={defaultFilters}
          getAPI={getAPI}
          seeAllFilters={true}
        />
      </ModalGroup>
      <div className="toggle-field tf-packed">
        <div>Include Required Filters</div>
        <Toggler
          checked={showRequiredFilterGroup}
          disabled={!!parentView}
          onChange={handleToggleChange}
        />
      </div>
      {showRequiredFilterGroup && (
        <ModalGroup
          id="requiredFilterGroup"
          label={
            <>
              Select Required Filters
              <span>
                {
                  <TooltipPopover
                    pointerPosition="right"
                    content={
                      'Select which filter(s) users must leverage when using this view. Users will be prompted to make a selection from this filter(s) in order to use this view.'
                    }
                    type="blueinfo"
                  />
                }
              </span>
            </>
          }
          text="Selected filter options are mandatory for this view"
        >
          <Filters
            addFilter={
              !!parentView
                ? null
                : (f: View.FiltersField) =>
                    setFilter({ ...f, isRequired: true }, false, false, true)
            }
            removeFilter={(f: View.FiltersField) =>
              setFilter({ ...f, isRequired: false }, false, false, true)
            }
            filters={requiredFilters}
            schemas={schemas}
            defaultFilters={defaultFilters}
            getAPI={getAPI}
            seeAllFilters={true}
          />
        </ModalGroup>
      )}
    </ModalGroups>
  );
};
